import React, { useState } from "react";
import "../../../src/App.css";
import logo from "../../assets/img/logo.jpg";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";

import { css } from "@emotion/react";
import { useHistory, useParams } from "react-router";
import axios from "axios";
import { URL_API } from "variable";
import { config } from "variable";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "react-bootstrap/Modal";

const Login = () => {
  const loaderCss = css`
    margin: auto;
  `;
  const { id } = useParams();

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [verificationCode, setVerificationCode] = useState();
  const history = useHistory();

  const onEmailChange = (e) => {
    setEmail([e.target.value]);
  };

  const onPasswordChange = (e) => {
    setPassword([e.target.value]);
  };

  const onVerifyCodeChange = (e) => {
    setVerificationCode([e.target.value]);
  };

  const onVerifyCode = async (e) => {
    e.preventDefault();
    let formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);
    formData.append("code", verificationCode);

    axios
      .post(URL_API + "login", formData)
      .then((response) => {
        if (response.status == 200) {
          localStorage.setItem(
            "njrujBf847hAfkxncmRbjfhy37AdyhbcKn84hdA8hggeras",
            response.data.access_token
          );
          handleClose();
          history.push("/admin/dashboard");
          toast.success("Logged In Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            // autoClose: 2000,
          });
        }
      })
      .catch((e) => {
        if (e.response) {
          if (e.response.status === 401) {
            toast.error("Verify Code Does Not Match", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            });
            // NotificationManager.error(e.response.data.errors.cnic[0]);
          }
        }
      });
  };

  const onCheckLogin = async (e) => {
    e.preventDefault();

    console.log("email", email, "password", password);

    let formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    axios
      // .post(URL_API + "auth/admin/login", formData)
      .post(URL_API + "auth/admin/login", formData)
      .then((response) => {
        console.log("login ", response.data.permission);
        if (response.status == 200) {
          localStorage.setItem(
            "njrujBf847hAfkxncmRbjfhy37AdyhbcKn84hdA8hggeras",
            response.data.access_token.token
          );
          localStorage.setItem("admin_name", response?.data?.admin?.full_name);
          localStorage.setItem(
            "permit",
            JSON.stringify(response?.data?.permission)
          );

          // console.log('permi',JSON.stringify(response.data.permission.admin_permissions));
          // localStorage.setItem('permit',JSON.stringify(response.data.permission));
          history.push("/admin/dashboard");
          toast.success("Logged In Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
        }
      })
      .catch((e) => {
        if (e.response) {
          if (e.response.status === 401) {
            toast.error("Invalid Credentials", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000
              ,
            });
            // NotificationManager.error(e.response.data.errors.cnic[0]);
          }
        }
      });
  };

  return (
    <>
      <div className="content login-app">
        {/* <img src= {public_img} /> */}
        <div className="container">
          <Row>
            <Col md="4" lg="3" sm="12"></Col>
            <Col md="4" lg="6" sm="12">
              <Card className="card-user">
                <br></br>

                <CardHeader className="ml-auto mr-auto">
                  <CardTitle tag="h6">
                    <img
                      src={logo}
                      width="130px"
                      height="52px"
                    // style={{backgroundColor:"#dc3545",padding:'10px'}}
                    />

                    <div style={{ paddingTop: "20px" }}>
                      <center>Admin LogIn</center>
                    </div>
                  </CardTitle>
                </CardHeader>
                <CardBody style={{ alignItems: "center" }}>
                  <form
                    onSubmit={(e) => {
                      onCheckLogin(e);
                    }}
                  >
                    <Row>
                      <Col className="ml-auto mr-auto" md="8">
                        <FormGroup>
                          <label>Email</label>
                          <Input
                            defaultValue={email}
                            placeholder="123@barakahhijama.com"
                            type="text"
                            name="email"
                            onChange={(e) => onEmailChange(e)}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="ml-auto mr-auto" md="8">
                        <FormGroup>
                          <label>Password</label>
                          <Input
                            placeholder="********"
                            type="password"
                            onChange={(e) => onPasswordChange(e)}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <div className="update ml-auto mr-auto">
                        <Button
                          className="btn btn-danger"
                          color="primary"
                          type="submit"
                          style={{ backgroundColor: "#0d6efdz" }}
                        >
                          Submit
                        </Button>
                      </div>
                    </Row>
                    <br></br>
                  </form>
                </CardBody>
              </Card>
            </Col>
            <Col md="4" lg="3" sm="12"></Col>
          </Row>
        </div>

        <>
          {/* <Button variant="primary" onClick={handleShow}>
            Launch demo modal
          </Button> */}
        </>
      </div>
    </>
  );
};

export default Login;
